import React, { useState } from 'react'
import styles from '../../styles/front/form/Form.module.sass'
import FormTemplate from "../form/Common"
import ScrollError from "../form/ScrollError"
import {
  buildCatalogFormKeys,
  buildCatalogOptionalKeys,
  normalizeCatalogAddressFormState,
  normalizeCatalogTelFormState,
  type CatalogAddressFormState,
  type CatalogTelFormState,
} from './catalogFormKeys'

type Prefecture = {
  prefecture_name: string,
  prefecture_code: string,
}

type CatarogForm = {
  name: string,
  name_kana: string,
  tel: string,
  email: string,
  zipcode: string,
  prefecture_code: string,
  city_name: string,
  address: string,
  extra_request: string
}

type CatarogFormProps = {
  prefectures: Prefecture[]
  catalog_form: CatarogForm
  errors?: {[key: string]: string[]}
  terms_path: string
  privacy_path: string
  theme_color: string
  tel_state?: CatalogTelFormState | number
  address_state?: CatalogAddressFormState | number
  is_show_company_name?: boolean
  is_show_job_title?: boolean
}

function CatarogForm(props: CatarogFormProps) {
  const {
    prefectures,
    catalog_form,
    errors,
    terms_path,
    privacy_path,
    theme_color,
    tel_state,
    address_state,
    is_show_company_name = false,
    is_show_job_title = false,
  } = props

  const telState = normalizeCatalogTelFormState(tel_state)
  const addressState = normalizeCatalogAddressFormState(address_state)

  const formKeys = buildCatalogFormKeys(telState, addressState)
  const optionalKeys = buildCatalogOptionalKeys(telState)
  const isShowAddress = addressState !== 'hidden'

  const [isValidForm, setIsValidForm] = useState(false)

  const handleValueChange = (isValid) => {
    setIsValidForm(isValid);
  };

  const [blankCheck, setBlankCheck] = useState(0)

  const scroll = window.innerWidth >= 989 ? 20 : 50

  const checkBlank = (e) =>{
    if(!isValidForm){
      e.preventDefault()
      setBlankCheck(blankCheck + 1)
      setTimeout(() => {
        let firstError =  document.getElementsByClassName("error")[0]
        let rectTop = firstError.getBoundingClientRect().top;
        let positionY = window.pageYOffset;
        let target = rectTop + positionY - scroll
        ScrollError(target)
      }, 10);
    }
  }

  return (
    <>
      <div className={styles.form}>
        <FormTemplate
          prefectures={prefectures}
          common_form={catalog_form}
          errors={errors}
          form_type="inquiry"
          isFormValid={handleValueChange}
          placeHolderText=""
          check={blankCheck}
          isShowAddress={isShowAddress}
          isShowCompanyName={is_show_company_name}
          isShowJobTitle={is_show_job_title}
          form_keys={formKeys}
          optional_keys={optionalKeys}
        />
        <div className={styles.formText}>
          <a href={terms_path} className={styles.link} rel="noopener" target="_blank">利用規約</a>
          と
          <a href={privacy_path} className={styles.link} rel="noopener" target="_blank">プライバシーポリシー</a>
          に同意して
        </div>
        <input type={'hidden'} name="commit" value=""/>
        <div className={styles.spSubmitContainer}>
          <input
            type={'submit'}
            name={'submit'}
            value={`${isValidForm ? '送信する' : 'まだ入力が完了していません'}`}
            className={`${styles.submitButton} ${isValidForm ? `${styles.submitButtonAbled} submit-color -${theme_color} -primary` : ""}`}
            onClick={(e)=> checkBlank(e)}
          />
        </div>
      </div>
    </>
  )
}

export default CatarogForm
